const PageLabel = {
  Login: {
    heading: 'Login',
    buttonLabel: 'Login',
    formLabelPin: 'Enter MPIN',
    formLabelPass: 'Enter Password',
    formLabelMobile: 'Enter Mobile',
    mobileNumber: 'Mobile Number',
    qatarIdNumber: 'Kuwait Civil ID Number',
    mobileCountryCode: '965',
  },
  Mpin: {
    heading: 'MPIN',
    buttonLabel: 'Confirm',
    formLabelPin: 'Enter MPIN',
    formLabelPass: 'Enter Password',
  },
  Register: {
    heading: 'Register',
    mobileNumber: 'Mobile Number',
    qatarIdNumber: 'Kuwait Civil ID Number',
    buttonLabel: 'Verify',
    mobileImagePath: '../assets/images/kuwait-flag.png',
    mobileCountryCode: '965',
  },
  AddCustomer: {
    heading: 'Add Your Details',
    buttonLabel: 'Submit',
  },
  ForgotPin: {
    heading: 'Forgot MPIN',
    buttonLabel: 'Proceed',
  },
  ChangeTransactionPassword: {
    heading: 'Change Transaction Password',
    oldPass: 'Current Transaction Password',
    newPass: 'New Transaction Password',
    confirmPass: 'Confirm New Transaction Password',
    buttonLabel: 'Confirm',
  },
  ForgotPass: {
    heading: 'Forgot Transaction Password',
    buttonLabel: 'Proceed',
  },
  ResetPin: {
    heading: 'Reset MPIN',
    buttonLabel: 'Reset',
  },
  ResetPass: {
    heading: 'RESET TRANSACTION PASSWORD',
    buttonLabel: 'Reset',
  },
  SetCredentials: {
    heading: 'Set Credentials',
    buttonLabel: 'Confirm',
  },
  VerifyOtp: {
    heading: 'Verify Otp',
    buttonLabel: 'Confirm',
    buttonOkLabel: 'Ok',
    buttonCancelLabel: 'Cancel',
  },
  TermsandCondition: {
    buttonLabel: 'Next',
    heading: 'Terms & Conditions',
  },
  Addbeneficiary: {
    buttonLabel: 'Add beneficiary',
    heading: 'Add Beneficiary',
    heading2: 'Beneficiaries',
  },
  AboutUS: {
    heading3: 'Profile',
    heading: 'About Us',
  },
  Transfer: {
    heading: 'Transfer',
    buttonLabel: 'transfer',
    message1: 'Value after decimal cannot exceed 3 digits!',
  },
  Calculator: {
    heading3: 'Choose transfer currency flag',
    heading: 'Currency Calculator',
    heading4: 'Choose transfer currency flag',
  },
  Rates: {
    heading: 'Rates',
  },
  RecentTransactions: {
    heading: 'Recent Transactions',
  },
  Mainnav: {
    home: 'home',
    Rates: 'Rates',
    Transfer: 'Transfer',
    CurrencyCalculator: 'Currency Calculator',
    MyBeneficiaries: 'My Beneficiaries ',
    MyTransfer: 'My Transfers',
    NewsEvents: ' News & Events',
    More: 'More',
    Branch: 'Branches',
    Logout: 'Logout',
  },
  Modal: {
    ModalText: 'Your inbox is getting full, would you like us to enable automatic archiving of old messages?',
  },
  Toast: {
    buttonLabel: 'Close',
  },
  ContactUs: {
    heading: 'Contact Us',
    heading1: 'ADDRESS',
    heading3: 'Get in Touch',
    buttonLabel: 'Submit',
  },
  Confirm: {
    heading: 'customer',
    heading2: 'beneficiary',
    heading3: 'Payment Mode',
    heading4: 'Transfer fee',
    heading5: 'Reciever Amount',
  },
  Menu: {
    Beneficiary: 'Beneficiary',
    Amount: 'Amount',
    Payment: 'Payment',
    Confirm: 'Confirm',
    Transfer: 'Transfer',
  },
  Amount: {
    ACNo: 'Account Number',
    ServiceMode: 'Service Mode:',
    TransferRate: 'Transfer Rate',
    TransferFee: 'Transfer Fee',
    Amountpayable: 'Amount payable',
  },
  ListError: {
    errorMessage: 'No Records Found',
  },
};

export default PageLabel;
